// src/lib/patientAuth.js

const PATIENT_AUTH_STORAGE_KEY = "orbismed_patient_auth";

export function getPatientAuthSession() {
  try {
    const raw = localStorage.getItem(PATIENT_AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setPatientAuthSession(session) {
  if (!session) return;
  localStorage.setItem(PATIENT_AUTH_STORAGE_KEY, JSON.stringify(session));
}

export function clearPatientAuthSession() {
  localStorage.removeItem(PATIENT_AUTH_STORAGE_KEY);
}

export function getPatientAccessToken() {
  return getPatientAuthSession()?.access_token || null;
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((char) => `%${`00${char.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export function isJwtExpired(token, skewSeconds = 20) {
  const payload = decodeJwtPayload(token);

  if (!payload?.exp) {
    return true;
  }

  const nowInSeconds = Math.floor(Date.now() / 1000);

  return payload.exp <= nowInSeconds + skewSeconds;
}

export function isPatientSessionExpired() {
  const token = getPatientAccessToken();

  if (!token) return true;

  return isJwtExpired(token);
}

export function patientLogout({
  redirectTo = "/signin",
  reason = "session_expired",
} = {}) {
  clearPatientAuthSession();

  try {
    sessionStorage.setItem("patient_logout_reason", reason);
  } catch {
    // ignore
  }

  const currentPath = window.location.pathname + window.location.search;

  if (!window.location.pathname.includes("/signin")) {
    const loginUrl = `${redirectTo}?reason=${encodeURIComponent(
      reason
    )}&returnTo=${encodeURIComponent(currentPath)}`;

    window.location.replace(loginUrl);
  }
}

export function requireValidPatientSession() {
  if (isPatientSessionExpired()) {
    patientLogout({ reason: "session_expired" });
    return false;
  }

  return true;
}